/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Error_Analyze_JobInputs */

const en_negotiation_error_analyze_job = /** @type {(inputs: Negotiation_Error_Analyze_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to analyze job`)
};

const de_negotiation_error_analyze_job = /** @type {(inputs: Negotiation_Error_Analyze_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to analyze job`)
};

const fr_negotiation_error_analyze_job = /** @type {(inputs: Negotiation_Error_Analyze_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to analyze job`)
};

const es_negotiation_error_analyze_job = /** @type {(inputs: Negotiation_Error_Analyze_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to analyze job`)
};

const it_negotiation_error_analyze_job = /** @type {(inputs: Negotiation_Error_Analyze_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to analyze job`)
};

const nl_negotiation_error_analyze_job = /** @type {(inputs: Negotiation_Error_Analyze_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to analyze job`)
};

const pl_negotiation_error_analyze_job = /** @type {(inputs: Negotiation_Error_Analyze_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to analyze job`)
};

const fi_negotiation_error_analyze_job = /** @type {(inputs: Negotiation_Error_Analyze_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to analyze job`)
};

const da_negotiation_error_analyze_job = /** @type {(inputs: Negotiation_Error_Analyze_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to analyze job`)
};

const sv_negotiation_error_analyze_job = /** @type {(inputs: Negotiation_Error_Analyze_JobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to analyze job`)
};

/**
* | output |
* | --- |
* | "Failed to analyze job" |
*
* @param {Negotiation_Error_Analyze_JobInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_error_analyze_job = /** @type {((inputs?: Negotiation_Error_Analyze_JobInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Error_Analyze_JobInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_error_analyze_job(inputs)
	if (locale === "fr") return fr_negotiation_error_analyze_job(inputs)
	if (locale === "es") return es_negotiation_error_analyze_job(inputs)
	if (locale === "it") return it_negotiation_error_analyze_job(inputs)
	if (locale === "nl") return nl_negotiation_error_analyze_job(inputs)
	if (locale === "pl") return pl_negotiation_error_analyze_job(inputs)
	if (locale === "fi") return fi_negotiation_error_analyze_job(inputs)
	if (locale === "da") return da_negotiation_error_analyze_job(inputs)
	if (locale === "sv") return sv_negotiation_error_analyze_job(inputs)
	return en_negotiation_error_analyze_job(inputs)
});